import countryCodes from "../data/country-codes.json";


type CountryCodeEntry = {
  code: string;
  name: string;
};

const countries = countryCodes as CountryCodeEntry[];
const countryByCode = new Map(
  countries.map((country) => [country.code.toUpperCase(), country])
);
const countryByName = new Map(
  countries.map((country) => [country.name.toLocaleLowerCase(), country])
);
const countryCodePattern = /^[A-Za-z]{2}$/;
const trailingCountryCodePattern = /\(([A-Za-z]{2})\)\s*$/;


const countryLabel = (country: CountryCodeEntry) =>
  `${country.name} (${country.code.toUpperCase()})`;


export const formatBuyerCountryDisplay = (value: unknown): string => {
  const rawValue = typeof value === "string" ? value.trim() : "";
  if (!rawValue) return "";

  const formattedMatch = rawValue.match(trailingCountryCodePattern);
  if (formattedMatch) {
    const code = formattedMatch[1].toUpperCase();
    const country = countryByCode.get(code);
    if (country) return countryLabel(country);

    const name = rawValue.slice(0, formattedMatch.index).trim();
    return name ? `${name} (${code})` : code;
  }

  if (countryCodePattern.test(rawValue)) {
    const country = countryByCode.get(rawValue.toUpperCase());
    return country ? countryLabel(country) : rawValue.toUpperCase();
  }

  const country = countryByName.get(rawValue.toLocaleLowerCase());
  return country ? countryLabel(country) : rawValue;
};
